import AMF from "./amf-parser";

export function parseFlvScriptData(arrayBuffer) {
  return AMF.parseScriptData(arrayBuffer.buffer, arrayBuffer.byteOffset, arrayBuffer.byteLength);;
}



